module.exports = __webpack_public_path__ + "media/song-sparrow-3.088ddbb3.mp3";